import { RESET_LOGIN_FORM_STATE } from "../types/AuthTypes";

const initialState = {
  loading: false,
  user: null,
  error: null,
  isAuthenticated: false,
  success: false,
  googleUser: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {

    case "GOOGLE_SIGN_IN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        isAuthenticated: false,
        success: false,
      };


    case "LOGIN_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        isAuthenticated: false,
        success: false,
      };
    case "LOGIN_SUCCESS":
     
      return {
        ...state,
        loading: false,
        user: {
          ...action.payload.user,
        },
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        error: null,
        isAuthenticated: true,
        success: true,
      };
    case "LOGIN_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
        isAuthenticated: false,
      };
    case "LOGOUT_SUCCESS":
      return {
        ...state,
        user: null,
        googleUser: null,
        accessToken: null,
        refreshToken: null,
        isAuthenticated: false,
        error: null,
        success: false,
      };

    case "LOGOUT_FAILURE":
      return {
        ...state,
        error: action.payload,
        success: false,
      };

    case RESET_LOGIN_FORM_STATE:
      return {
        ...state,
        loading: false,
        error: null,
        success: false,
      };
    default:
      return state;
  }
};

export default authReducer;
